export default "__VITE_ASSET__CB0c_FGg__"